module.exports = __webpack_public_path__ + "static/media/23.7ad91043.webp";